import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a6e5052c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "x" }
const _hoisted_2 = { class: "gridBlock__titles" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_4 = { class: "gridBlock__branches" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "branch__infoBox" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "branch__nameBox" }
const _hoisted_9 = { class: "branch__name" }
const _hoisted_10 = { class: "branch__email" }
const _hoisted_11 = {
  key: 0,
  class: "branch__myBranch"
}
const _hoisted_12 = { class: "branch__total" }
const _hoisted_13 = { class: "branch__counted" }
const _hoisted_14 = {
  key: 0,
  class: "transactions"
}
const _hoisted_15 = { class: "transactions__titlesBox" }
const _hoisted_16 = { class: "transactions__title" }
const _hoisted_17 = { class: "transactions__title" }
const _hoisted_18 = { class: "transactions__title" }
const _hoisted_19 = { class: "transactions__title" }
const _hoisted_20 = { class: "transactions__title" }
const _hoisted_21 = { class: "transactions__title" }
const _hoisted_22 = { class: "transactions__item_id" }
const _hoisted_23 = { class: "transactions__item_date" }
const _hoisted_24 = { class: "transactions__item_description" }
const _hoisted_25 = { class: "transactions__item_sum" }
const _hoisted_26 = { class: "transactions__item_type" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommonButtonMore = _resolveComponent("CommonButtonMore")!
  const _component_WithLoader = _resolveComponent("WithLoader")!
  const _component_CommonModal = _resolveComponent("CommonModal")!

  return (_openBlock(), _createBlock(_component_CommonModal, {
    name: _ctx.modalName,
    title: _ctx.$t('All branches'),
    isModalAllBranches: true,
    onCloseModal: _ctx.closeModal,
    class: "x"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('Total turnover')), 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('Counted')), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.structureList, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.user.id
            }, [
              _createElementVNode("div", {
                class: "branch",
                onClick: ($event: any) => (_ctx.openTransactions(item.user.id))
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("img", {
                    class: "branch__avatar",
                    src: `https://www.gravatar.com/avatar/${item.user.id}.jpg`,
                    alt: ""
                  }, null, 8, _hoisted_7),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(item.user.name), 1),
                    _createElementVNode("div", _hoisted_10, _toDisplayString(item.user.email), 1)
                  ]),
                  (item.user.id == _ctx.userId)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.$t('My branch')), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_12, _toDisplayString(item.turnover), 1),
                _createElementVNode("div", _hoisted_13, _toDisplayString(item.turnover_limited), 1)
              ], 8, _hoisted_5),
              ((_ctx.transactionsList && Number(_ctx.transactionsList[0]?.ref_user_id) === Number(item.user.id)))
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('id')), 1),
                      _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('Date')), 1),
                      _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('Description')), 1),
                      _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('Sum')), 1),
                      _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('Type')), 1),
                      _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('Status')), 1)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transactionsList, (item, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i,
                        class: "transactions__itemsBox"
                      }, [
                        _createElementVNode("div", _hoisted_22, _toDisplayString(item.id), 1),
                        _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.dateDay(+item.date + 1)), 1),
                        _createElementVNode("div", _hoisted_24, _toDisplayString(item.description), 1),
                        _createElementVNode("div", _hoisted_25, "+" + _toDisplayString(item.sum) + " " + _toDisplayString(item.currency.symbol), 1),
                        _createElementVNode("div", _hoisted_26, _toDisplayString(item.marketplace), 1),
                        _createElementVNode("div", {
                          class: _normalizeClass(['transactions__item_status', { transactions__item_statusSuccess: +item.status === 2 }])
                        }, _toDisplayString(item.status_name), 3)
                      ]))
                    }), 128)),
                    (_ctx.canFetchMore)
                      ? (_openBlock(), _createBlock(_component_WithLoader, {
                          key: 0,
                          state: _ctx.fetchMoreState
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_CommonButtonMore, {
                              onClick: ($event: any) => (_ctx.fetchMore(item.user.id))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("More")), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1032, ["state"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }, 8, ["name", "title", "onCloseModal"]))
}